import {
  AddVendorResponse,
  BaseReducerState,
  Vendor,
} from '../../../services'
import { ActionTypes } from '../actions'

export type AddVendorState = BaseReducerState & {
  data: Vendor | null
}

export const initialState: AddVendorState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const addVendorReducer = (
  state: AddVendorState = initialState,
  action: { type: string; res: any }
): AddVendorState => {
  switch (action.type) {
    case `${ActionTypes.ADD_VENDOR}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.ADD_VENDOR}_SUCCESS`: {
      const { success, data, message } = <AddVendorResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.ADD_VENDOR}_FAILURE`: {
      const res = <AddVendorResponse>action.res
      const { message } = res || {}
      if (res) (res as any).error = (res as any).error ?? message
      const { error } = (res || {}) as any
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }
    }

    case `${ActionTypes.ADD_VENDOR}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
